module.exports = __webpack_public_path__ + "/images/logo-ico-paypal-full.853fd2f.svg";